<ng-select [items]="items"
           [placeholder]="placeholder"
           [formControl]="control"
           [appendTo]="appendTo"
           [disabled]="disabled"
           [searchable]="searchable"
           [clearable]="clearable"
>
</ng-select>
<app-error *ngIf="control.touched && control.invalid">{{requiredMessage}}</app-error>
